<template>
  <div class="hello">
    <div class="left">
      <el-menu :default-active="selectName" active-text-color="#ffffff" :unique-opened="uniqueOpened">
        <div v-for="(one,index) in selectList" :key="index">
          <div v-if="!one.hidden">
            <el-submenu class="top-menu-title" v-if="one.sub.length > 0" :index="prePath + '-' + index + ''">
              <template slot="title">{{one.title}}</template>
              <div v-for="(two, index2) in one.sub" :key="index + '-' + index2">
                <div v-if="!two.hidden">
                  <!--二层菜单-->
                  <el-submenu v-if="two.sub.length > 0" :index="prePath + '-' + index + '-' + index2">
                    <template slot="title">{{two.title}}</template>
                    <!--三层菜单-->
                    <div v-for="(three, index3) in two.sub" :key="index + '-' + index2 + '-' + index3">
                      <div v-if="!three.hidden">
                        <el-submenu v-if="three.sub.length > 0" @click="menuItemEvent(three)"
                                    :index="prePath + '-' + index + '-' + index2 + '-' + index3">
                          <template slot="title">{{three.title}}</template>
                        </el-submenu>
                        <menu-item v-else :item="three" v-on:childMethod="menuItemEvent" :openDelay="openDelay"></menu-item>
                      </div>
                    </div>
                  </el-submenu>
                  <menu-item v-else :item="two" v-on:childMethod="menuItemEvent" :openDelay="openDelay"></menu-item>
                </div>
              </div>

            </el-submenu>
            <el-menu-item class="top-menu-title" v-else @click="menuItemEvent(one)"
                          :key="one.linkUrl" :index="one.linkUrl">{{one.title}}
            </el-menu-item>
          </div>
        </div>
      </el-menu>


    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations} from "vuex";
  import MenuItem from './MenuItem'

  export default {
    props: ["menuData"],
    components: {
      MenuItem: MenuItem
    },
    data() {
      return {
        selectList: [],
        openDelay: 400,
        prePath: '',
        uniqueOpened: false,
        active: '',
      };
    },
    created() {
      this.getMenuData();
      this.initSelectName();
    },
    computed: {
      ...mapState(["selectName"])
    },
    mounted() {
      this.getMenuData()
    },
    watch: {
      /* eslint-disable */
      '$route'(to, from) {
        let toPath = to.path
        let fromPath = from.path
        toPath = toPath.indexOf('/') === 0 ? toPath.substring(1) : toPath
        fromPath = fromPath.indexOf('/') === 0 ? fromPath.substring(1) : fromPath
        let toPaths = toPath.split('/')
        let fromPaths = fromPath.split('/')
        let isSampPath = toPaths[0] === fromPaths[0]
        if (to.path.indexOf(this.prePath) === -1 ||
          (to.path.indexOf(this.prePath) === 0 && to.path.lastIndexOf('/') === 0) || !isSampPath) {
          this.getMenuData()
        }
        this.initSelectName();
      },
    },
    methods: {
      ...mapMutations([
        "setSelectName", //将 `this.setSelectName(amount)` 映射为 `this.$store.commit('setSelectName', amount)`
        "setRefreshPage"
      ]),

      getMenuData() {
        let url = window.location.href;
        this.menuData.forEach(ele => {
          if (url.indexOf(ele.index) !== -1) {
            this.selectList = ele.menu
            this.prePath = ele.index
            this.active = ele.active
            this.$emit("setCommonUrls", ele.uri)
          }
        })
      },

      initSelectName() {
        let url = window.location.href;
        let linkUrl = url.split(this.prePath + "/")[1];
        if (linkUrl === undefined) {
          this.setSelectName(this.active)
        }
        
        if (linkUrl) {
          linkUrl = linkUrl.indexOf("#") === -1 ? linkUrl : linkUrl.split('#')[0]
          this.setSelectName(linkUrl);
          this.setRefreshPage(this.prePath);
        }
        
        if (!linkUrl && this.prePath) {
          this.setRefreshPage(this.prePath);
        }
      },

      menuItemEvent(item) {
        if (item) {
          let linkUrl = item.linkUrl
          if (this.selectName === linkUrl) {
            return;
          }
          linkUrl = linkUrl.indexOf("#") === -1 ? linkUrl : linkUrl.split('#')[0]
          this.setSelectName(linkUrl);
          this.$router.push({path: this.prePath + '/' + linkUrl})
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  @deep: ~'>>>';
  .el-menu-item.is-active, .el-menu-item.is-active:hover {
    background-color: #3eb94e;
  }

  .el-submenu {
    .el-menu {
      padding: 5px 0;
    }
    .el-menu-item {
      /*background-color: #f9f9f9;*/
      height: 40px;
      line-height: 40px;
    }
    @{deep} ul {
      padding: 5px 0;
      background-color: #f9f9f9;
    }
  }

  .el-submenu li:hover {
    background-color: #ecf5ff;
  }

  .el-divider--horizontal {
    margin: 0;
  }

  .el-menu, .hello, .left {
    overflow: hidden;
  }

  .el-menu {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .hello {
    padding: 5px 0;
    margin-right: 2px;
    .el-menu-item.top-menu-title {
      border-bottom: 1px solid #e6e6e6;
      height: 40px;
      line-height: 40px;
    }
    @{deep} .el-submenu__title {
      border-bottom: 1px solid #e6e6e6;
      height: 40px;
      line-height: 40px;
    }
    .top-menu-title .el-submenu .el-menu-item {
      padding-left: 55px !important;
      border-bottom: 1px solid #e6e6e6;
    }
  }

  @{deep} .el-submenu.is-active .el-submenu__title {
    /*border-bottom: 1px solid */
    border-bottom-color: #e6e6e6;
  }
</style>




// WEBPACK FOOTER //
// src/components/leftMune.vue